import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routeTitle } from '../lib/navigation';

export const APP_NAME = 'Tasky';

// A page that sets its own title (PageHeader) "claims" it; the route-level fallback then stays out of the way.
// Child effects run before parent effects, so the claim is visible when Layout's effect runs.
let claimedBy: string | null = null;

/** Sets document.title to "<title> · Tasky" while the component is mounted. */
export function usePageTitle(title?: string | false): void {
  useEffect(() => {
    if (!title) return;
    claimedBy = title;
    document.title = `${title} · ${APP_NAME}`;
    return () => {
      if (claimedBy === title) claimedBy = null;
      document.title = APP_NAME;
    };
  }, [title]);
}

/** Layout-level fallback: title from the navigation labels for pages that have no PageHeader yet. */
export function useRouteTitle(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    if (claimedBy) return;
    const title = routeTitle(pathname);
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
  }, [pathname]);
}
